import type { VoteOnPoll401ErrorsItem } from './voteOnPoll401ErrorsItem';

/**
 * 에러 응답
 */
export type VoteOnPoll401 = {
  /** 에러 코드 */
  code: string;
  /** 상세 에러 목록 */
  errors?: VoteOnPoll401ErrorsItem[];
  /** 에러 메시지 */
  message: string;
  /** 에러가 발생한 API 경로 */
  path?: string;
  /** HTTP 상태 코드 */
  status: number;
  /** 에러 발생 시간 */
  timestamp: string;
};
